import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import * as WebFont from 'webfontloader';
import { ToastContainer } from './shared/toast/toast-container';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor(viewport: ViewportScroller) {
    viewport.setOffset([0, 80]);
  }
  ngOnInit(): void {
    WebFont.load({
      custom: {
        families: ['Material Symbols Rounded'],
      },
      timeout: 45000,
    });
  }
}
